module.exports = __webpack_public_path__ + "img/bh_12.5bf35cbb.jpg";